import { useEffect, useState } from "react"

// helpers
import Api from "@/_helpers/Api"
import Skeleton from "react-loading-skeleton"

// providers
import { trans } from "@/_providers/Translation"

export default function TechnicianInventory() {
  const [parts, setParts] = useState([])
  const [technicians, setTechnicians] = useState([])
  const [filters, setFilters] = useState({ technician_id: "" })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(
      `analytics/technicians-parts-in-van?technician_id=${filters.technician_id}`,
    )
      .then((res) => {
        setParts(res.data.parts_in_van)
        setTechnicians(res.data.technicians)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function handleFilterChange(e) {
    setFilters((prev) => ({ ...prev, technician_id: e.target.value }))
  }

  return (
    <div className="technician-inventory">
      <div className="head">
        <h3>Състояние на инвентара</h3>
        <div className="right">
          {loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              onChange={handleFilterChange}
              value={filters.technician_id || technicians[0]?.id || ""}
            >
              {technicians.map((tech) => (
                <option key={tech.id} value={tech.id}>
                  {tech.full_name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={100} count={3} />
      ) : parts.length === 0 ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>№</th>
              <th>Име</th>
              <th>Наличност</th>
            </tr>
          </thead>
          <tbody>
            {parts.map((part) => (
              <tr key={part.product_id}>
                <td>{part.product_id}</td>
                <td>{part.part_name}</td>
                <td>{part.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
